/*
 * @Author: etong
 * @Date: 2021-03-18 14:20:41
 * @LastEditTime: 2021-05-28 16:38:13
 * @LastEditors: your name
 * @Description: 
 * @FilePath: \oak\src\store\views\common\index.js
 * Think first, Program later
 */
const common = {
    state: {
        jjflowTrackList: [], // 审批流数据
        jjflowModalIsShow: false, // 审批流弹框是否呈显示状态
    },

    mutations: {
        // 审批流数据赋值
        SET_JJFLOW_DATA: ( state, data ) => {
            state.jjflowTrackList = [];
            state.jjflowTrackList = data;
        },
        // 审批流弹框是否显示
        SET_JJFLOW_MODAL_SHOW: ( state, data ) => {
            state.jjflowModalIsShow = false;
            state.jjflowModalIsShow = data;
        },
    },

    actions: {

    }
}

export default common